/**
*功能名称：数据库类型接口
*创 建 人：马少华
*日    期：2022/02/25 10:15:17
*/
import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";
export class DbDataBaseClassApi extends DbCenterBaseApi {
    public get ControllerName(): any {
        return 'dbDatabaseclass';
    }
   //数据拉取（不分页）仅仅拉却简单内容
    public QueryDataBaseClass(isdelete:number,isAll:boolean){
        return this.send({isdelete,isAll}, 'QueryDataBaseClass', Methods.GET);
    }
    //获取单条数据
    public GetSigleDataBaseClass(id:number){
        return this.send({id},"getEntity",Methods.GET); 
    } 
    //保存单挑数据
    public SaveSigleDataBaseClass(entity:any){
        return this.send(entity,"update",Methods.POST);
    }
    
 
}